export default "__VITE_ASSET__acdDWdBk__"